import { ChargeSetting, ChargeSettingParty } from "graphql/charge-settings/queries";
import { NumberFormatValues } from 'react-number-format';

export const defaultForAll = "Default for All";

export const getSettingName = (setting: ChargeSetting) => {
  const { letter, number, code } = setting;

  if (letter && !number && !code) return `Default for ${letter}`;

  if (letter && number && !code) return `${letter}-${number}`;

  if (!letter && !number && code) return code;

  return defaultForAll;
};

export function orderSettingsByName(settings: ChargeSetting[]) {
  return settings.sort((entryA, entryB) => getSettingName(entryA).localeCompare(getSettingName(entryB)));
}

export function isNumberAllowed({ floatValue = 0 }: NumberFormatValues) {
  if (floatValue <= 100) return true;
  return false;
}

export const convertPercentStringToNumber = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  let value = Number(e.target.value.replace('%', ''));
  if (Number.isNaN(value)) {
    value = 0;
  }

  return value / 100;
};

export function onNumberChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, onChange: (value: number) => void) {
  const number = convertPercentStringToNumber(e);
  onChange(number);
}

export function formatValue(value: number | undefined) {
  return value ? (value * 100) : value;
}

export function formatPercentLabel(value: number) {
  return `${parseFloat((value * 100).toFixed(2))}%`;
}

export function formatPartyLabel(parties?: ChargeSettingParty[] | null) {
  return (parties ?? []).length
    ? (parties ?? []).map((p) => `${p.role} ${Math.round(p.percent * 100)}%`).join(', ')
    : '—';
}
